import {Component, Input, OnInit} from '@angular/core';
import {
  PyramidCategory,
  PyramidLegendItem
} from 'src/app/components/categories-pyramid-display/categories-pyramid-display.component';

@Component({
  selector: 'app-pyramid',
  templateUrl: './pyramid.component.html',
  styleUrls: ['./pyramid.component.scss']
})
export class PyramidComponent implements OnInit {
  @Input() categories: PyramidCategory[] = [];
  @Input() legend: PyramidLegendItem[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
